import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./app";
import "./main.css";
import "@aws-amplify/ui-react/styles.css";
import * as Sentry from "@sentry/react";
import {
  configureAmplifyAuth,
  setUpAmplifyTranslation,
} from "./components/amplify_auth";
import { configureOpenApi } from "./api/configureOpenApi";

setUpAmplifyTranslation();

const rootElement = document.getElementById("app")!;

const startApp = async () => {
  await Promise.all([configureOpenApi(), configureAmplifyAuth()]);

  if (!rootElement.innerHTML) {
    const root = ReactDOM.createRoot(rootElement, {
      onUncaughtError: Sentry.reactErrorHandler(),
      onCaughtError: Sentry.reactErrorHandler(),
      onRecoverableError: Sentry.reactErrorHandler(),
    });
    root.render(<App />);
  }
};
startApp().catch((error) => {
  console.error("Kon frontend config niet laden", error);
});
